import { gql } from '@apollo/client';

export default gql`
  mutation AccountCreate($input: AccountCreateInput!) {
    accountCreate(input: $input) {
      token
      company {
        id
        databaseId
        name
        plan {
          id
          databaseId
          identifier
        }
        industry {
          id
          name
        }
        howHeard {
          type
          detail
        }
      }
      user {
        id
        databaseId
        firstName
        lastName
        emailAddress
        createdAt
        phoneNumber
        acceptedTos
      }
      errors {
        message
        path
        error
      }
    }
  }
`;
